import { render, staticRenderFns } from "./detali.vue?vue&type=template&id=2ec9070b&scoped=true"
import script from "./detali.vue?vue&type=script&lang=js"
export * from "./detali.vue?vue&type=script&lang=js"
import style0 from "./detali.vue?vue&type=style&index=0&id=2ec9070b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec9070b",
  null
  
)

export default component.exports